import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=2a66459f&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=ts"
export * from "./privacy.vue?vue&type=script&lang=ts"
import style0 from "./privacy.vue?vue&type=style&index=0&id=2a66459f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a66459f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Element1H1: require('/codebuild/output/src1993466134/src/acredo-website/components/element/Element1H1.vue').default,Breadcrumb: require('/codebuild/output/src1993466134/src/acredo-website/components/Breadcrumb.vue').default,MetaTitle: require('/codebuild/output/src1993466134/src/acredo-website/components/meta/MetaTitle.vue').default})
